<template>
  <div class="wt2-position-picker">
    <position
      v-for="p in allPositions"
      :id="p"
      :key="p"
      :selected="isSelected(p)"
      @selected="select"
    ></position>
  </div>
</template>

<script>
export default {
  components: {
    position: {
      template: '<div :class="classObj" @click="select"></div>',
      props: {
        id: {
          type: String,
          required: true,
        },
        selected: {
          type: Boolean,
          default: false,
        },
      },
      computed: {
        isDisabled() {
          return this.id.includes('MIDDLE');
        },
        classObj() {
          const res = {};
          if (this.isDisabled) {
            res['-disabled'] = true;
          }
          if (this.selected) {
            res['-selected'] = true;
          }
          res[this.id.toLowerCase()] = true;
          return res;
        },
      },
      methods: {
        select() {
          if (this.isDisabled) {
            return;
          }
          this.$emit('selected', this.id);
        },
      },
    },
  },

  props: {
    selectedPosition: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      allPositions: [
        'TOP_LEFT',
        'TOP_MIDDLE',
        'TOP_RIGHT',
        'MIDDLE_LEFT',
        'MIDDLE_MIDDLE',
        'MIDDLE_RIGHT',
        'BOTTOM_LEFT',
        'BOTTOM_MIDDLE',
        'BOTTOM_RIGHT',
      ],
    };
  },

  methods: {
    isSelected(position) {
      return position === this.selectedPosition;
    },
    select(id) {
      this.$emit('selected', id);
    },
  },
};
</script>
